<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>

<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="container-fluid">
      <div class="row align-items-center my-4">
        <div class="col-md-6">
          <div class="heading">
            <h3 style="color: #504b4b" class="font-weight-bold m-0">
              Mentorship Metrics Dashboard
            </h3>
          </div>
        </div>

        <div class="col-md-6 text-right">
          <button
            (click)="captureAndSavePdf()"
            class="btn btn-primary savebtn rounded"
          >
            Capture to PDF
          </button>
        </div>
      </div>

      <div id="captureArea">
        <div class="row">
          <div class="col-md-12">
            <div
              class="row mb-4 align-items-end filtersvalue justify-content-md-start mr-0"
            >
              <div class="col-3 pr-1">
                <div
                  class="form-group position-relative m-0 d-flex align-items-center"
                >
                  <label for="" class="font-weight-normal m-0 w-50"
                    >From Date</label
                  >
                  <input
                    type="date"
                    class="form-control"
                    [max]="today"
                    name="startDate"
                    placeholder="Select Start Date"
                    [(ngModel)]="startDate"
                    (keydown)="blockTyping($event)"
                    (ngModelChange)="onStartDateChange($event)"
                    autocomplete="off"
                    novalidate
                  />
                  <small
                    *ngIf="isSubmitted && !startDate && !dateInvalid"
                    class="text-danger position-absolute"
                    style="bottom: -20px"
                    >From Date is required.</small
                  >
                </div>
              </div>

              <div class="col-3 pr-1">
                <div
                  class="form-group position-relative m-0 d-flex align-items-center"
                >
                  <label for="" class="font-weight-normal m-0 w-50 text-center"
                    >To Date</label
                  >
                  <input
                    type="date"
                    class="form-control mr-3"
                    [max]="today"
                    autocomplete="off"
                    novalidate
                    name="endDate"
                    placeholder="Select End Date"
                    [(ngModel)]="endDate"
                    (keydown)="blockTyping($event)"
                  />
                  <small
                    *ngIf="isSubmitted && !endDate && !dateInvalid"
                    class="text-danger position-absolute ml-3"
                    style="bottom: -20px"
                    >To Date is required.</small
                  >
                </div>
              </div>

              <div class="col-auto px-1">
                <button class="border-0 cross-icon1" (click)="onSearch()">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </button>
              </div>

              <div class="col-auto px-1">
                <button class="border-0 cross-icon1" (click)="onReset()">
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                </button>
              </div>
              <div class="col-12 position-relative">
                <small
                  *ngIf="isSubmitted && dateInvalid && startDate && endDate"
                  class="text-danger text-center mt-1 position-absolute"
                >
                  Please ensure the From Date is earlier than or equal to the To
                  Date
                </small>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToMentorList('mentor')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Total Mentors request</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("mentor") }}</span>
                  <img
                    src="../assets/img/icons/total-b.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToMentorList('approved_mentor')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">No. of Approved application</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("approved_mentor") }}</span>
                  <img
                    src="../assets/img/icons/approved.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToMentorList('pending_mentor')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">No. of pending application for approval</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("pending_mentor") }}</span>
                  <img
                    src="../assets/img/icons/pending.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToMentorList('rejected_mentor')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">No. of Rejected application</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("rejected_mentor") }}</span>
                  <img
                    src="../assets/img/icons/reject.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-req-sent-by-mentee')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">
                  Total no. of request sent by mentees to the mentors on the
                  platform
                </h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("requests_sent_by_mentees") }}</span>
                  <img
                    src="../assets/img/icons/req-sent.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-req-accept-by-mentor')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">
                  No. of requests accepted by mentors on the mentorship platform
                </h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{
                    getCountByType("accepted_requests_by_mentors")
                  }}</span>
                  <img
                    src="../assets/img/icons/req-pending.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-pending-req-by-mentor')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Total no. of request pending at Mentor</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{
                    getCountByType("pending_requests_by_mentors")
                  }}</span>
                  <img
                    src="../assets/img/icons/pending.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-rejected-req-by-mentor')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">
                  Total no. of request rejected/disconnected by Mentor
                </h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{
                    getCountByType("disconnected_rejected_requests_by_mentors")
                  }}</span>
                  <img
                    src="../assets/img/icons/pending.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-meetings')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Total No of mentorship meetings scheduled</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("mentorship_meetings") }}</span>
                  <img
                    src="../assets/img/icons/meetings.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-successful-meetings')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Total No. of successful meetings</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{
                    getCountByType("mentorship_meetings_started")
                  }}</span>
                  <img
                    src="../assets/img/icons/start.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-hours-received')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Total mentorship hours received</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("total_mentorship_time") }}</span>
                  <img
                    src="../assets/img/icons/hours.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-repeated-meetings')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">No. of repeated meetings</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("repeated_meetings") }}</span>
                  <img
                    src="../assets/img/icons/repeated.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-logins-by-mentors')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Total no. of logins by the mentors</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("mentor_logins") }}</span>
                  <img
                    src="../assets/img/icons/login.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-smart-match')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">
                  No. of users who have used the smart match feature
                </h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("smart_match_users") }}</span>
                  <img
                    src="../assets/img/icons/smart.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-mentee-feedback')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">No. of mentee who gave feedback</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("mentee_feedback") }}</span>
                  <img
                    src="../assets/img/icons/feedback-a.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-mentor-feedback')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">No. of mentors who gave feedback</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("mentor_feedback") }}</span>
                  <img
                    src="../assets/img/icons/feedback-b.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-mentor-ratings')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Avg rating given by the mentors</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("avg_rating_mentor") }}</span>
                  <img
                    src="../assets/img/icons/rating-a.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-mentee-ratings')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Avg rating given by mentee</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("avg_rating_mentee") }}</span>
                  <img
                    src="../assets/img/icons/rating-c.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
            <a
              (click)="goToAnotherComp('mentorship-most-search-mentors')"
              class="card flex-fill w-100 text-decoration-none text-dark"
            >
              <div class="card-body tile">
                <h5 class="mb-0">Most Searched Mentors</h5>
                <div class="d-flex justify-content-between align-items-end">
                  <span>{{ getCountByType("most_searched_mentors") }}</span>
                  <img
                    src="../assets/img/icons/mentor-2.png"
                    class="img-fluid"
                    alt="logo"
                  />
                </div>
              </div>
              <div class="card-footer">
                <a href="javascript:void(0);">
                  <span>Read More <i class="fa fa-arrow-right ml-2"></i></span>
                </a>
              </div>
            </a>
          </div>
        </div>

        <div class="row">
          <!-- Industry Wise -->
          <div class="col-md-12">
            <div class="card p-3 chart-container position-relative">
              <p class="graph_title text-center">
                Industry wise distribution of mentors
              </p>

              <div style="display: flex; justify-content: space-around">
                <div
                  class="chart-container"
                  [ngStyle]="
                    barChartIndWiseLabels.length != 0
                      ? { height: '400px', width: '100%' }
                      : { height: '200px', width: '100%' }
                  "
                >
                  <ng-container
                    *ngIf="barChartIndWiseLabels.length != 0; else noIndData"
                  >
                    <canvas
                      baseChart
                      [datasets]="barChartIndWiseData"
                      [labels]="barChartIndWiseLabels"
                      [options]="barChartIndWiseOptions"
                      [plugins]="indWiseBarChartPlugins"
                      [legend]="barChartIndLegend"
                      [chartType]="'horizontalBar'"
                    >
                    </canvas>
                  </ng-container>
                </div>
                <ng-template #noIndData>
                  <div
                    class="d-flex flex-column justify-content-center align-items-center mt-5"
                  >
                    <p class="">No data available for selected date range.</p>
                  </div>
                </ng-template>
              </div>
              <div class="loader-overlay">
                <div class="spinner"></div>
              </div>
            </div>
          </div>

          <!-- Experience Wise -->
          <div class="col-md-4 d-flex">
            <div class="card p-3 chart-container position-relative">
              <p class="graph_title text-center">
                Experience wise distribution of mentors
              </p>
              <div style="display: flex; justify-content: space-around">
                <div class="chart-container" style="height: 300px; width: 100%">
                  <!-- <app-scroll-bar [step]="8" [axis]="'x'"> -->
                  <ng-container
                    *ngIf="barChartExpWiseLabels.length != 0; else noExpData"
                  >
                    <canvas
                      baseChart
                      [datasets]="barChartExpWiseData"
                      [labels]="barChartExpWiseLabels"
                      [options]="barChartExpWiseOptions"
                      [plugins]="expWiseBarChartPlugins"
                      [legend]="barChartExpLegend"
                      [chartType]="'pie'"
                    >
                    </canvas>
                  </ng-container>

                  <ng-template #noExpData>
                    <div
                      class="d-flex flex-column justify-content-center align-items-center h-100"
                    >
                      <p class="">No data available for selected date range.</p>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div class="loader-overlay">
                <div class="spinner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
